module.exports = __webpack_public_path__ + "media/images/logo/menu-39d9bf53f7ec073431e4bd45f50c9d13.png";